import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

interface FeatureToggleProps {
  id: string
  label: string
  description?: string
  checked: boolean
  onChange: (checked: boolean) => void
}

export function FeatureToggle({ id, label, description, checked, onChange }: FeatureToggleProps) {
  return (
    <div className="flex items-start space-x-3 space-y-0">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onChange}
      />
      <div className="space-y-1 leading-none">
        <Label
          htmlFor={id}
          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
        >
          {label}
        </Label>
        {description && (
          <p className="text-xs text-muted-foreground">{description}</p>
        )}
      </div>
    </div>
  )
}
